import React, { useEffect, useRef, useState } from "react";
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import * as RB from "react-bootstrap";
import * as utils from "../../Utils/comman";

function View({ rowData, setShowGraph }) {
  const navigate = useNavigate();
  const chartRef = useRef(null);
  const chartInstance = useRef(null);
  const [counterExpense, setCounterExpense] = useState({});

  const colorMap = {
    gift: "#757E7F", // SO Pop
    meeting: "#FFDB58", // Meeting
    brand: "#F9A8A2", // Branding
    sales: "#77B2E8", // Sales
  };

  useEffect(() => {
    if (rowData) getExpenses(rowData.counter_id);
  }, [rowData]);

  const getExpenses = (counterId) => {
    utils
      .callAPI("get", `meeting/counter/view?counter_id=${counterId}`)
      .then((res) => setCounterExpense(res || {}))
      .catch(() => setCounterExpense({}));
  };

  useEffect(() => {
    if (chartRef.current && counterExpense) {
      const ctx = chartRef.current.getContext("2d");

      if (chartInstance.current) chartInstance.current.destroy();

      // Updated: branding → brand
      const expenseTypes = ["gift", "meeting", "brand", "sales"];
      const labels = ["SO Pop", "Meeting", "Branding", "Sales"];

      const dataValues = expenseTypes.map((type) =>
        parseFloat(counterExpense[`${type}_amt`] || 0)
      );

      const colors = expenseTypes.map((type) => colorMap[type]);

      chartInstance.current = new Chart(ctx, {
        type: "pie",
        data: {
          labels,
          datasets: [
            {
              label: "Amount",
              data: dataValues,
              backgroundColor: colors,
              borderColor: "#ffffff",
              borderWidth: 2,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            datalabels: { display: false },
            legend: { display: true, position: "bottom" },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function (tooltipItem) {
                  const value = tooltipItem.raw || 0;
                  return `${tooltipItem.label}: ₹${value.toLocaleString()}`;
                },
              },
            },
          },
        },
        plugins: [ChartDataLabels],
      });
    }

    return () => {
      if (chartInstance.current) chartInstance.current.destroy();
    };
  }, [counterExpense]);

  const handleBack = () => setShowGraph(false);

  const handleNavigate = (type) =>
    navigate(`/marketing/counter-detail/${rowData?.counter_id}?type=${type}`);

  const ColorDot = ({ color }) => (
    <span
      style={{
        display: "inline-block",
        width: "14px",
        height: "14px",
        backgroundColor: color,
        marginRight: "8px",
      }}
    ></span>
  );

  return (
    <div className="section-body">
      <RB.Card className="card shadow">
        <RB.Card.Header className="border-0">
          <div className="card-header-action">
            <h5></h5>
            <Link className="btn btn-underline me-2" onClick={handleBack}>
              Close
            </Link>
          </div>
        </RB.Card.Header>

        <RB.Card.Body>
          <Row>
            {/* Chart */}
            <Col
              md={4}
              className="d-flex flex-column justify-content-center align-items-center"
            >
              <div
                className="w-100 d-flex justify-content-center"
                style={{ height: "300px" }}
              >
                <canvas ref={chartRef}></canvas>
              </div>
              <p className="text-muted mt-2">
                *Note: Hover over the chart segments to view details
              </p>
            </Col>

            {/* Counter Details */}
            <Col md={3} className="d-flex flex-column">
              <h6 className="fw-bold text-secondary pb-2 border-bottom">
                Counter Details
              </h6>

              <p className="mb-1">{rowData?.counter_no || "-"}</p>
              <p className="mb-1">{rowData?.dealership_name || "-"}</p>

              <p
                onClick={() => handleNavigate("sales")}
                style={{
                  fontSize: "1.1rem",
                  color: "black",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                <ColorDot color={colorMap.sales} />
                Sales Amount = ₹
                {parseFloat(counterExpense?.sales_amt || 0).toLocaleString()}/-
              </p>
            </Col>

            {/* Expense Break-up */}
            <Col md={5} className="d-flex flex-column">
              <h6 className="fw-bold text-secondary pb-2 border-bottom">
                Expense Break-up
              </h6>

              {["gift", "meeting", "brand"].map((type) => (
                <p
                  key={type}
                  onClick={() => handleNavigate(type)}
                  style={{
                    fontSize: "1.1rem",
                    color: "black",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  <ColorDot color={colorMap[type]} />
                  {type === "gift"
                    ? "SO Pop"
                    : type === "brand"
                    ? "Branding"
                    : type.charAt(0).toUpperCase() + type.slice(1)}{" "}
                  Amount = ₹
                  {parseFloat(
                    counterExpense?.[`${type}_amt`] || 0
                  ).toLocaleString()}
                  /-
                </p>
              ))}

              <hr />

              <h5 className="fw-bold">
                Total Marketing Expense = ₹
                {parseFloat(counterExpense.total_amt || 0).toLocaleString()}/-
              </h5>

              <h5 className="fw-bold">
                Total Sales = ₹
                {parseFloat(counterExpense.sales_amt || 0).toLocaleString()}/-
              </h5>

              <h5
                className="fw-bold"
                style={{
                  color:
                    parseFloat(counterExpense.total_percent || 0) >= 3
                      ? "red"
                      : "green",
                }}
              >
                Budget Percentage ={" "}
                {(parseFloat(counterExpense.total_percent || 0) || 0).toFixed(
                  2
                )}
                %
              </h5>
            </Col>
          </Row>
        </RB.Card.Body>
      </RB.Card>
    </div>
  );
}

export default View;
